import { Color, DefaultValue } from '@billy/design-system'
import styled from '@emotion/styled'

export const OrganizationsSearchResultsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: 45vh;
  border-top: 1px solid ${Color.Grey200};
  border-radius: 0 0 ${DefaultValue.BorderRadius} ${DefaultValue.BorderRadius};
  background-color: ${Color.White};
`

export const ResultsList = styled.div`
  overflow: auto;
`
